'use client';

import { Disclosure } from '@headlessui/react';
import classNames from 'classnames';
import { links } from './constants';
import CoulmnsLinks from './columns-links';
import DownloadApps from './download-apps';
import { IconArrowSquareDown } from '../svg-symbols/icons';
function ExpandableFooterLinks() {
  return <div className='my-5 flex w-full flex-col lg:hidden' data-sentry-component="ExpandableFooterLinks" data-sentry-source-file="expandable-links.tsx">
            {links.map((link, index) => {
      return <Disclosure defaultOpen={true} as='div' className='border-t border-text-darkGray' key={`${link.title}-${index}`}>
                        {({
          open
        }) => <>
                                <Disclosure.Button className='mb-5 flex w-full justify-between px-2 py-4'>
                                    <span className='text-body-14 font-bold text-white'>{link.title}</span>
                                    <IconArrowSquareDown className={`${open ? 'rotate-180 transform' : ''} h-6 w-6 text-white`} />
                                </Disclosure.Button>
                                <Disclosure.Panel className='mb-8 mt-2 px-2'>
                                    <CoulmnsLinks collection={link.collection} />
                                </Disclosure.Panel>
                            </>}
                    </Disclosure>;
    })}
            <Disclosure as='div' className='border-t border-text-darkGray' data-sentry-element="Disclosure" data-sentry-source-file="expandable-links.tsx">
                {({
        open
      }) => <>
                        <Disclosure.Button className={classNames('flex w-full justify-between px-2 py-4', {
          open: 'mb-6'
        })}>
                            <span className='text-body-14 font-bold text-white'>دریافت اپلیکیشن</span>
                            <IconArrowSquareDown className={`${open ? 'rotate-180 transform' : ''} h-6 w-6 text-white`} />
                        </Disclosure.Button>
                        <Disclosure.Panel className='mt-2 px-2'>
                            <DownloadApps />
                        </Disclosure.Panel>
                    </>}
            </Disclosure>
        </div>;
}
export default ExpandableFooterLinks;